export const questionnaireStatusMessage = (status, endDate) => {
    let result = {};

    const givenDate = new Date(endDate);
    const today = new Date();

    const displayDate = new Date(givenDate).toLocaleString("en-GB", {
        day: "numeric",
        month: "short",
        year: "numeric",
    });

    switch (status) {
        case "open":
            result = {
                severity: "warning",
                message: `Please complete this questionnaire`,
            };

            if (endDate) {
                result = {
                    severity: "warning",
                    message: `Please complete this questionnaire by ${displayDate}`,
                };

                if (givenDate < today) {
                    result = {
                        severity: "warning",
                        message: `This questionnaire should have been completed by ${displayDate}`,
                    };
                }
            }

            break;

        case "completed":
            result = { severity: "success", message: "Completed" };
            break;

        default:
            break;
    }

    return result;
};
